// extracted by mini-css-extract-plugin
export default {"title":"NewCaseForm3_title__XhRcc","content":"NewCaseForm3_content__JjcNT"};